$(document).ready(function () {
  $(".magnify-img").each(function(){
    $(this).blowup({
      // round magnifying glass
      round : true,

      // width/height of magnifying glass
      width : 200,
      height : 200,

      // background color
      background : "#FFF",

      // border shadow
      shadow : "0 8px 17px 0 rgba(0, 0, 0, 0.2)",

      // border styles
      border : "2px solid #FFF",

      // displays cursor
      cursor : true,

      // z-index
      zIndex : 999999,
    
      // scale factor
      scale : 0.375,

      // custom CSS classes
      customClasses : ""
    });
  });
})
